export default __webpack_public_path__ + "static/media/023-phone booth.ff888137.svg";